export default __webpack_public_path__ + "4342d6a33796badf07ab98b1c51ca733.png";